import loadable from '@loadable/component'

const LoadableTextEditor = loadable(() =>
  import(/* webpackChunkName: "textEditor" */ './textEditor')
)

export { LoadableTextEditor as TextEditor }
